import { classifyError, ERROR_KIND } from './classifyError';
import { getNotifier } from './notifyUser';
import {
  markUnstableNoticeShown,
  shouldShowUnstableNotice,
} from './networkNoticeState';

const isAppOffline = () => (
  typeof navigator !== 'undefined' && !navigator.onLine
);

const UNSTABLE_CONNECTION_TOAST = {
  type: 'network',
  title: 'Instabile Verbindung',
  message: 'Einige Inhalte konnten nicht geladen werden. Bitte prüfe deine Internetverbindung.',
  duration: 6000,
};

const getOperationType = (operation) => {
  const definition = operation?.query?.definitions?.find(
    (item) => item.kind === 'OperationDefinition'
  );
  return definition?.operation || 'query';
};

const shouldSkipGlobalError = (operation, classified) => {
  const context = operation?.getContext?.() || {};

  if (context.skipGlobalError) return true;
  if (context.silentError) return true;

  if (classified.kind === ERROR_KIND.VALIDATION) return true;
  if (classified.kind === ERROR_KIND.BLOCKED) return true;

  const operationName = operation?.operationName || '';
  if (operationName.startsWith('Introspection')) return true;

  return false;
};

export const handleApolloError = ({
  graphQLErrors,
  networkError,
  operation,
}) => {
  if (!graphQLErrors?.length && !networkError) return;

  const operationType = getOperationType(operation);
  const error = { graphQLErrors, networkError };
  const classified = classifyError(error, { operation: operationType });

  if (shouldSkipGlobalError(operation, classified)) return;

  let notifier;
  try {
    notifier = getNotifier();
  } catch {
    return;
  }

  if (classified.kind === ERROR_KIND.ACTION_FAILED) {
    notifier.toast({
      type: 'error',
      title: classified.title,
      message: classified.message,
      duration: 6000,
    });
    return;
  }

  if (classified.kind === ERROR_KIND.NETWORK || classified.kind === ERROR_KIND.LOAD_FAILED) {
    if (isAppOffline()) return;
    if (!shouldShowUnstableNotice()) return;

    markUnstableNoticeShown();
    notifier.toast(UNSTABLE_CONNECTION_TOAST);
    return;
  }

  if (classified.kind === ERROR_KIND.AUTH) {
    notifier.toast({
      type: 'warning',
      title: classified.title,
      message: classified.message,
      duration: 7000,
    });
    return;
  }

  if (classified.kind === ERROR_KIND.PAYMENT || classified.kind === ERROR_KIND.UPLOAD) {
    notifier.toast({
      type: 'error',
      title: classified.title,
      message: classified.message,
      duration: 6000,
    });
  }
};

export default handleApolloError;
